/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsOrphanedGcpAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsOrphanedGcpAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsOrphanedGcpAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsOrphanedGcpAdvisorResource>): RecommendationForFinopsOrphanedGcpAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsOrphanedGcpAdvisorResource(), model);
        RecommendationForFinopsOrphanedGcpAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsOrphanedGcpAdvisorResource>): RecommendationForFinopsOrphanedGcpAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsOrphanedGcpAdvisorResource.newInstance(<RecommendationForFinopsOrphanedGcpAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsOrphanedGcpAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsOrphanedGcpAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsOrphanedGcpAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsOrphanedGcpAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
